/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { loginInsured } from "../../Auth/Hooks/authSlice.jsx";
import Swal from "sweetalert2";
import { getDashboardPathForRole, getValidAuthSession, saveAuthSession, USER_ROLES } from "../../utils/authSession";
import "../LoginPage/LoginPage.css";

const InsuredLoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  React.useEffect(() => {
    const session = getValidAuthSession();
    if (session) navigate(getDashboardPathForRole(session.role), { replace: true });
  }, [navigate]);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await dispatch(loginInsured({ username, password })).unwrap();
      const userType = result.data?.user_info?.type;
      const isWorkshop = userType === "workshop";
      saveAuthSession({
        token: result.data.token,
        role: isWorkshop ? USER_ROLES.WORKSHOP : USER_ROLES.INSURED,
        expires: result.data.expires ?? result.data.expires_at,
      });

      Swal.fire({
        icon: "success",
        title: "Login Berhasil",
        text: "Selamat datang!",
        timer: 2000,
        showConfirmButton: false,
      });

      navigate(getDashboardPathForRole(isWorkshop ? USER_ROLES.WORKSHOP : USER_ROLES.INSURED), { replace: true });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: error?.message || "Terjadi kesalahan saat login.",
      });
    }
  };

  return (
    <div className="section-login">
      <div className="login-content">
        <div className="image-top-left">
          <img src="/asset_login_top.png" alt="Latar Jastan" />
        </div>
        <div className="content">
          <div className="content-left">
            <div className="header-content-login">
              <img src="/logo.png" alt="Logo Jastan" />
              <h2>Mitra Terpercaya Dalam Proteksi</h2>
              <p>
                Selamat datang di Jastan Protect – temukan bengkel rekanan
                terdekat dari lokasi Anda dengan mudah.
              </p>
            </div>
            <div className="icons-login">
              <img src="/asset_login_1.png" alt="Ikon Aset Jastan" />
            </div>
          </div>
          <div className="content-right">
            <div className="card-content">
              <div className="header-card">
                <span className="login-card-eyebrow">Portal layanan</span>
                <h1>Masuk Akun</h1>
                <p>Untuk akun Tertanggung dan Bengkel rekanan.</p>
              </div>
              <form className="login-form" onSubmit={handleSubmit}>
                <label htmlFor="username">Nama Pengguna</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  required
                />
                <label htmlFor="password">Kata Sandi</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="**********"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <button type="button" className="toggle-password" onClick={toggleShowPassword} aria-label={showPassword ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}>
                    {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </button>
                </div>

                <div className="forgot-password">
                  <a href="#">Lupa kata sandi?</a>
                </div>

                <button type="submit" className="sign-in-btn" disabled={loading} aria-busy={loading}>
                  {loading && <span className="login-spinner" aria-hidden="true" />}
                  {loading ? "Memproses..." : "Masuk"}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="image-bottom-right">
          <img src="/asset_login_bottom.png" alt="Latar Jastan" />
        </div>
      </div>
    </div>
  );
};

export default InsuredLoginPage;
